
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_cGFrbw_ from 'pako';
import { instantiate } from './composeApp.uninstantiated.mjs';
import "./custom-formatters.js"

const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    'pako': _ref_cGFrbw_
})).exports;

export const {
memory,
_initialize
} = exports


